/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import {
  COL_GRAYOUT_IMG_URL,
  COL_PLATFORM_IMG_URL,
  COLLECTOR_CATAGORY_OTT,
  COLLECTOR_CATAGORY_TVOS,
  PLA_GRAYOUT_IMG_URL,
} from "../../app/Constants/Constants";
import { addCustomEvent } from "../../app/Utilities/utils";
import { COL_IMG_URL } from "../../constants/Constants";
import { isGrayOut } from "../collector/helper";

export const getListViewObj = (player) => ({
  id: player.id,
  url: `${COL_IMG_URL}${player.icon}`,
  alt: player.playerDescription,
  name: player.playerName,
  version: player.playerVersion,
  icon: player.icon,
  type: player.type,
  category: player.category,
  collectorStatus: player.status,
  supportCmcd: player.supportCmcd,
  restricted: player.restricted,
  supportSampling: player.supportSampling,
  platformIcon:
    player.platformIcon !== null
      ? `${
          isGrayOut(player.playerName)
            ? PLA_GRAYOUT_IMG_URL
            : COL_PLATFORM_IMG_URL
        }${player.platformIcon}`
      : null,
  documentationUrl: player.documentationUrl,
  isGrayOut: isGrayOut(player.playerName),
});
export const getDataSourceObj = (player) => ({
  id: player.id,
  url: `${COL_IMG_URL}${player.icon}`,
  alt: player.playerDescription,
  name: `${COL_IMG_URL}${player.playerName}`,
  version: player.playerVersion,
  icon: player.icon,
  type: player.type,
  category:
    player.category === COLLECTOR_CATAGORY_TVOS
      ? COLLECTOR_CATAGORY_OTT
      : player.category,
  collectorStatus: player.status,
  supportCmcd: player.supportCmcd,
  restricted: player.restricted,
  supportSampling: player.supportSampling,
  platformIcon:
    player.platformIcon !== null
      ? `${
          isGrayOut(player.playerName)
            ? PLA_GRAYOUT_IMG_URL
            : COL_PLATFORM_IMG_URL
        }${player.platformIcon}`
      : null,
  documentationUrl: player.documentationUrl,
  isGrayOut: isGrayOut(player.playerName),
});
export const getDatapipePlayerBO = (players) => {
  const collectorConfigMap = {};

  for (const collectorConfig of players) {
    const { collectorId } = collectorConfig;
    if (collectorConfigMap[collectorId]) {
      continue;
    }
    collectorConfigMap[collectorId] = {
      id: collectorConfig.collectorId,
      name: collectorConfig.collectorName,
      collectorType: collectorConfig.collectorType,
      icon: collectorConfig.icon,
      eventList: collectorConfig?.eventList?.map((event) => ({
        deprecated: event.deprecated,
        id: event.dictionaryVersionDatapointMappingId,
        label: event.label,
        name: event.name,
        required: event.required,
        selected: event.required || event.selected,
        supportedMediaTypes: event.supportedMediaTypes,
      })),
      fluxDataList: collectorConfig?.fluxDataList?.map((flux) => ({
        deprecated: flux.deprecated,
        id: flux.dictionaryVersionDatapointMappingId,
        label: flux.label,
        name: flux.name,
        required: flux.required,
        selected: flux.required || flux.selected,
      })),
      metaDataList: collectorConfig?.metaDataList?.map((meta) => ({
        deprecated: meta.deprecated,
        group: meta.group,
        id: meta.dictionaryVersionDatapointMappingId,
        label: meta.label,
        name: meta.name,
        required: meta.required,
        selected: meta.required || meta.selected,
      })),
    };
    collectorConfigMap[collectorId] = addCustomEvent(
      collectorConfigMap[collectorId],
    );
  }
  return collectorConfigMap;
};
export const getDatapipePlayerBO_v3 = (players) => {
  return players.reduce((acc, config) => {
    const customList = (list) =>
      (list || []).map(({ reqired, selected, ...rest }) => ({
        selected,
        ...rest,
      }));

    const generateUniqueHexUUID = () => {
      const timestamp = performance.now().toString(16);
      const randomHex = crypto
        .getRandomValues(new Uint8Array(8))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");

      return timestamp + randomHex;
    };
    const customEventList = (data) => {
      const groupedData = [];

      data.forEach((item) => {
        const {
          dataPointId,
          name,
          label,
          required,
          deprecated,
          mediaType,
          selected,
        } = item;
        let event = groupedData.find((event) => event.name === name);

        if (!event) {
          const generatedUniqueHexUUID = generateUniqueHexUUID();
          event = {
            label,
            name,
            dataPointId:
              generatedUniqueHexUUID + (name?.replace(/\s+/g, "_") || ""),
            selected,
            required,
            deprecated,
            supportedMediaTypes: [],
            selectedMediaTypes: [],
            datapointsList: [],
            originalId: dataPointId,
          };
          groupedData.push(event);
        }

        if (!event.supportedMediaTypes.includes(mediaType)) {
          event.supportedMediaTypes.push(mediaType);
          event.supportedMediaTypes.sort();
        }
        if (selected && !event.selectedMediaTypes.includes(mediaType)) {
          event.selectedMediaTypes.push(mediaType);
        }
        // Use the correct variable `dataPointId`
        event.datapointsList.push({
          id: dataPointId, // Correct variable name here
          mediaTypeName: mediaType,
          selected,
        });

        if (selected) {
          event.selected = true;
        }
      });
      return groupedData;
    };

    let collectorConfig = {
      configId: config.configId,
      collectorId: config.collectorId,
      collectorName: config.collectorName,
      configName: config.configName,
      collectorIcon: config.collectorIcon,
      plugin: config.plugin,
      general: {
        ...config.general,
        eventList: customEventList(config?.general?.eventList || []),
        fluxDataList: customList(config?.general?.fluxDataList || []),
        metaDataList: customList(config?.general?.metaDataList || []),
      },
    };

    // if (config.plugin) {
    collectorConfig = {
      ...collectorConfig,
      pluginId: config?.pluginId || null,
      pluginIcon: config?.pluginIcon || null,
      pluginName: config?.pluginName || null,
    };
    // }
    if (config.plugin && config.mediaPlayer) {
      collectorConfig.mediaPlayer = {
        eventList: customEventList(config?.mediaPlayer?.eventList || []),
        fluxDataList: customList(config?.mediaPlayer?.fluxDataList || []),
        metaDataList: customList(config?.mediaPlayer?.metaDataList || []),
      };
    }
    if (config?.custom) {
      collectorConfig.custom = (config.custom || []).map((customItem) => ({
        dataPointId: customItem.dataPointId,
        name: customItem.name,
        label: customItem.label,
        required: customItem.required,
        deprecated: customItem.deprecated,
        selected: customItem.selected,
      }));
    }
    if (config?.vendor) {
      collectorConfig.vendor = (config.vendor || []).map((customItem) => ({
        dataPointId: customItem.dataPointId,
        name: customItem.name,
        label: customItem.label,
        required: customItem.required,
        deprecated: customItem.deprecated,
        selected: customItem.selected,
      }));
    }
    acc[config.configId] = collectorConfig;
    return acc;
  }, {});
};
export const getV3PlayerBO = (players) => ({
  id: players.id,
  name: players.collectorName,
  collectorType: players.type,
  icon: players.icon,
  eventList: players?.eventList?.map((event) => ({
    deprecated: event.deprecated,
    id: event.id,
    label: event.label,
    name: event.name,
    required: event.required,
    selected: true,
    supportedMediaTypes: event.supportedMediaTypes,
  })),
  fluxDataList: players?.fluxDataList?.map((flux) => ({
    deprecated: flux.deprecated,
    id: flux.id,
    label: flux.label,
    name: flux.name,
    required: flux.required,
    selected: true,
  })),
  metaDataList: players?.metadataList?.map((meta) => ({
    deprecated: meta.deprecated,
    group: meta.group,
    id: meta.id,
    label: meta.label,
    name: meta.name,
    required: meta.required,
    selected: true,
  })),
});

const generateUniqueHexUUID = () => {
  const timestamp = performance.now().toString(16);
  const randomHex = crypto
    .getRandomValues(new Uint8Array(8))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

  return timestamp + randomHex;
};

const customEventListV3 = (data) => {
  const groupedData = [];

  data?.forEach((events) => {
    const {
      dataPointId,
      messageName: name,
      dataPointName: label,
      required,
      deprecated,
      mediaType,
    } = events;

    let event = groupedData.find((event) => event.name === name);
    if (!event) {
      const generatedUniqueHexUUID = generateUniqueHexUUID();
      event = {
        name,
        label,
        dataPointId:
          generatedUniqueHexUUID + (name?.replace(/\s+/g, "_") || ""),
        selected: true,
        required,
        deprecated,
        supportedMediaTypes: [],
        selectedMediaTypes: [],
        datapointsList: [],
        originalId: dataPointId,
      };
      groupedData.push(event);
    }

    if (mediaType && !event.supportedMediaTypes.includes(mediaType)) {
      event.supportedMediaTypes.push(mediaType);
      event.supportedMediaTypes.sort();
    }

    if (mediaType && !event.selectedMediaTypes.includes(mediaType)) {
      event.selectedMediaTypes.push(mediaType);
    }

    event.datapointsList.push({
      id: dataPointId,
      mediaTypeName: mediaType,
      selected: true,
    });

    if (mediaType) {
      event.selected = true;
    }
  });
  return groupedData;
};

export const getV3PlayerBO_v2 = (collector, id) => {
  // Initialize the result object with common properties
  let result = {
    configId: id,
    collectorId: collector.playerId,
    collectorName: collector.collectorName,
    configName: collector.name,
    collectorIcon: collector?.collectorIcon
      ? `${collector.collectorIcon}.svg`
      : null,
    plugin: collector.pluginSupported,
    disabled: collector.disabled,
  };
  // if( collector.pluginSupported){
  result = {
    ...result,
    pluginId: collector?.playerId || null,
    pluginIcon: collector?.mediaPlayerIcon
      ? `${collector.mediaPlayerIcon}.svg`
      : null,
    pluginName: collector?.mediaPlayerName || null,
    adFrameWorkId: collector?.adFrameworkId || null,
    adFrameworkIcon: collector?.adFrameworIcon || null,
    adFrameworkName: collector?.adFrameworkName || null,
  };
  // }
  // General section with events, fluxdata, and metadata
  const general = {
    eventList: customEventListV3(
      collector?.authoredDataPoints?.general?.eventList || [],
    ),
    fluxDataList:
      collector.authoredDataPoints?.general?.fluxDataList?.map((flux) => ({
        dataPointId: flux?.dataPointId,
        name: flux?.dataPointName,
        label: flux?.dataPointName,
        required: flux?.required,
        deprecated: flux?.deprecated,
        selected: true,
      })) || [],

    metaDataList:
      collector.authoredDataPoints?.general?.metaDataList?.map((meta) => ({
        dataPointId: meta?.dataPointId,
        name: meta?.messageName,
        label: meta?.dataPointName,
        required: meta?.required,
        deprecated: meta?.deprecated,
        selected: true,
        group: meta?.group,
      })) || [],
  };

  // Only include general if it contains data
  if (
    general.eventList.length > 0 ||
    general.fluxDataList.length > 0 ||
    general.metaDataList.length > 0
  ) {
    result.general = general;
  }

  // MediaPlayer section if pluginSupported is true
  if (collector.pluginSupported) {
    const plugin = {};
    const mediaPlayer = {
      eventList: customEventListV3(
        collector.authoredDataPoints.mediaPlayer?.eventList || [],
      ),
      fluxDataList:
        collector?.authoredDataPoints?.mediaPlayer?.fluxDataList?.map(
          (flux) => ({
            dataPointId: flux?.dataPointId,
            name: flux?.dataPointName,
            label: flux?.dataPointName,
            required: flux?.required,
            deprecated: flux?.deprecated,
            selected: true,
          }),
        ) || [],

      metaDataList:
        collector?.authoredDataPoints?.mediaPlayer?.metaDataList?.map(
          (meta) => ({
            dataPointId: meta?.dataPointId,
            name: meta?.messageName,
            label: meta?.dataPointName,
            required: meta?.required,
            deprecated: meta?.deprecated,
            selected: true,
            group: meta?.group,
          }),
        ) || [],
    };

    // Only include mediaPlayer if it contains data
    if (
      mediaPlayer.eventList.length > 0 ||
      mediaPlayer.fluxDataList.length > 0 ||
      mediaPlayer.metaDataList.length > 0
    ) {
      result.mediaPlayer = mediaPlayer;
    }
  }

  // Custom section if custom is not empty
  const custom =
    collector?.authoredDataPoints?.custom?.map((customItem) => ({
      dataPointId: customItem?.dataPointId,
      name: customItem?.messageName,
      label: customItem?.dataPointName,
      required: customItem?.required,
      deprecated: customItem?.deprecated,
      selected: true,
    })) || [];

  // Only include custom if it contains data
  if (custom.length > 0) {
    result.custom = custom;
  }

  // Custom section if custom is not empty
  const vendor =
    collector?.authoredDataPoints?.vendor?.map((vendorItem) => ({
      dataPointId: vendorItem?.dataPointId,
      name: vendorItem?.messageName,
      label: vendorItem?.dataPointName,
      required: vendorItem?.required,
      deprecated: vendorItem?.deprecated,
      selected: true,
    })) || [];

  // Only include custom if it contains data
  if (vendor.length > 0) {
    result.vendor = vendor;
  }

  // alias items

  const alias = {
    events:
      collector.authoredDataPoints?.alias?.events?.map((event) => ({
        dataPointId: event?.dataPointId,
        name: event?.dataPointName,
        label: event?.dataPointName,
        required: event?.required,
        deprecated: event?.deprecated,
        selected: true,
      })) || [],

    metadata:
      collector.authoredDataPoints?.alias?.metadata?.map((meta) => ({
        dataPointId: meta?.dataPointId,
        name: meta?.messageName,
        label: meta?.dataPointName,
        required: meta?.required,
        deprecated: meta?.deprecated,
        selected: true,
        group: meta?.group,
      })) || [],
  };

  // Only include general if it contains data
  if (alias.events.length > 0 || alias.metadata.length > 0) {
    result.alias = alias;
  }

  return result;
};
